import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorHandlerService } from '@inera/common';
import { Observable, throwError } from 'rxjs';
import { ToastService } from './toast.service';

@Injectable()
export class ClientToolsErrorHandlerService extends ErrorHandlerService {
  private router = inject(Router);
  private toastService = inject(ToastService);

  error(error: any): Observable<never> {
    const displayValues = this.getDisplayValues(error);

    displayValues['subStatus'] = error?.error?.subStatus;
    let silent = error?.error?.silent || false;
    if (typeof error?.error === 'string') {
      try {
        const data = JSON.parse(error.error);
        silent = data?.silent || false;
      } catch (ex) {
        console.debug('failed to parse error message: ' + ex);
      }
    }

    switch (error.status) {
      case 401:
        if (displayValues.messages.includes('No HTTP session')) {
          displayValues.error = 'Ingen session';
          displayValues.messages = ['Du har ingen giltig session.'];

          this.router.navigate(['/loggedout']);
        } else if (displayValues.messages.includes('Session expired')) {
          displayValues.error = 'Session utgången';
          displayValues.messages = ['Sessionen har gått ut.'];

          this.router.navigate(['/loggedout'], { queryParams: { message: 'sessionexpired' } });
        }
        break;

      case 403:
        if (displayValues.messages.includes('theme')) {
          break;
        } else {
          displayValues.error = 'Åtkomst förbjuden';
          displayValues.messages = ['Du har inte behörighet att göra detta'];
        }
        break;

      case 404:
        if (displayValues.messages.find(message => message.includes('You+have+no+valid+authenticated+session'))) {
          displayValues.error = 'Ingen session';
          displayValues.messages = ['Du har ingen giltig session.'];

          this.router.navigate(['/loggedout'], { queryParams: { message: 'sessionexpired' } });
        }
        break;

      case 400:
      case 422:
        if (!silent) {
          this.toastService.addToast({
            type: 'warning',
            message: displayValues.messages,
            title: displayValues.error,
          });
        }
        break;

      case 500:
        if (!silent) {
          this.toastService.addToast({
            type: 'danger',
            message: 'Ett fel har uppstått. Försök igen.',
            title: 'Något gick fel',
          });
        }
        break;

      default:
        if (error.url == '/public/health/liveness') {
          silent = true;
          console.warn('failed to get liveness endpoint');
        }
        if (!silent) {
          this.toastService.addToast({
            type: 'danger',
            message: displayValues.messages,
            title: displayValues.error,
          });
        }
        break;
    }

    return throwError(() => error);
  }
}
